<template>
  <div>
    <div class="flex items-start mb-2">
      <div class="flex items-center cursor-pointer" @click="openPopup1">
        <feather-icon icon="AlertCircleIcon" class="mr-1" style="cursor: pointer; width: 18px; color: #7e72f2" />
        <span style="color: #7e72f2"> 안전검사 대상 유해·위험기계기구 및 검사주기 </span>
      </div>
    </div>

    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      title-type="hint"
      hint="안전검사 대상 기계 등"
      section-title="안전검사 현황"
      :with-date-picker="true"
      :with-date-picker-position="isMobile ? 'bottom' : 'top'"
      date-picker-title1="대상"
      date-picker-title2="최종검사일"
      not-input="true"
      @input="inputPhoto"
      @openPopup="openPopup2"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" />

    <!-- 팝업 -->
    <vs-popup id="popAlert" title="안전검사 대상 유해·위험기계기구 및 검사주기" :active.sync="showPopup1">
      <table id="PopupTable" style="margin-bottom: 20px">
        <tr>
          <th>안전검사 대상품</th>
          <th>안전검사 시기 및 주기</th>
        </tr>
        <tr>
          <td class="text-center p-3">크레인(이동식 제외)</td>
          <td rowspan="3" class="text-center p-3">사업장에 설치가 끝난 날부터 3년 이내에<br/>
            최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시<br/>
            (건설현장에서 사용하는 것은 최초로 설치한 날로부터 6개월마다 실시)</td>
        </tr>
        <tr>
          <td class="text-center p-3">리프트(이삿짐운방용 제외)</td>
        </tr>
        <tr>
          <td class="text-center p-3">곤돌라</td>
        </tr>

        <tr>
          <td class="text-center p-3">이동식 크레인</td>
          <td rowspan="3" class="text-center p-3">자동차관리법 제8조에 따른 신규등록 이후 3년 이내에<br/>
            최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시</td>
        </tr>
        <tr>
          <td class="text-center p-3">이삿짐운반용 리프트</td>
        </tr>
        <tr>
          <td class="text-center p-3">고소작업대</td>
        </tr>

        <tr>
          <td class="text-center p-3">압력용기</td>
          <td rowspan="9" class="text-center p-3">사업장에 설치가 끝난 날로부터 3년 이내에<br/>
            최초안전검사를 실시하되, 그 이후로부터 2년마다 실시<br/>
            (공정안전보고서를 제출하여 확인을 받은 압력용기는 4년마다 실시)</td>
        </tr>
        <tr>
          <td class="text-center p-3">프레스</td>
        </tr>
        <tr>
          <td class="text-center p-3">전단기</td>
        </tr>
        <tr>
          <td class="text-center p-3">롤러기</td>
        </tr>
        <tr>
          <td class="text-center p-3">사출성형기</td>
        </tr>
        <tr>
          <td class="text-center p-3">원심기</td>
        </tr>
        <tr>
          <td class="text-center p-3">국소배기장치</td>
        </tr>
        <tr>
          <td class="text-center p-3">컨베이어</td>
        </tr>
        <tr>
          <td class="text-center p-3">산업용 로봇</td>
        </tr>

      </table>
    </vs-popup>
    <vs-popup id="popAlert" title="유해ㆍ위험 기계·기구(방호장치)" :active.sync="showPopup2">
      <table id="PopupTable" style="margin-bottom: 20px">
        <tr>
          <th>유해ㆍ위험 기계·기구(방호장치)</th>
        </tr>
        <tr>
          <td class="p-3">
            <div style="padding: 0 20px; min-width: 300px;">
              <p class="mb-1">1. 프레스</p>
              <p class="mb-1">2. 전단기</p>
              <p class="mb-1">3. 크레인(정격 하중이 2톤 미만인 것은 제외)</p>
              <p class="mb-1">4. 리프트</p>
              <p class="mb-1">5. 압력용기</p>
              <p class="mb-1">6. 곤돌라</p>
              <p class="mb-1">7. 국소 배기장치(이동식은 제외)</p>
              <p class="mb-1">8. 원심기(산업용만 해당)</p>
              <p class="mb-1">9. 롤러기(밀폐형 구조는 제외)</p>
              <p class="mb-1">10. 사출성형기</p>
              <p class="mb-1">11. 고소작업대(화물자동차, 특수자동차에 탑재)</p>
              <p class="mb-1">12. 컨베이어</p>
              <p class="mb-1">13. 산업용 로봇</p>
            </div>
          </td>
        </tr>
      </table>
    </vs-popup>

  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspect from "@/components/TableInspectNo";
import DateSelector from "@/components/selector/DateSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";

export default {
  components: {
    PhotoUploadGridModule,
    TableCustom,
    FieldSelectModule,
    FileUploadModule,
    TableInspect,
    DateSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  computed: {
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
  },
  data() {
    return {
      showPopup1: false,
      showPopup2: false,
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],
        targets: "",
      },
    };
  },
  methods: {
    openPopup1() {
      this.showPopup1 = true;
    },
    openPopup2() {
      this.showPopup2 = true;
    },
    inputPhoto(v) {
      this.form.targets = v.map((item) => item.input).join(", ");
    },
  },
};
</script>

<style scoped lang="scss">
#PopupTable {
  width: 100%;
  border-collapse: collapse;

  &,
  tr,
  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 700;
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    background: #f9f9f9;
    padding: 10px 0;
  }

  li {
    margin-left: 16px;
    &::marker {
      content: " · ";
      font-size: 1.2em;
    }
  }
}
</style>
